var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.showSummary
        ? _c(
            "div",
            { staticClass: "content_head" },
            [
              _c("div", { staticClass: "content_head_left" }, [
                _c("img", { attrs: { src: _vm.gameData.gameIcon, alt: "" } }),
                _c("div", { staticClass: "content_head_text" }, [
                  _c("p", [_vm._v(_vm._s(_vm.gameData.gameName))]),
                  _c("span", [_vm._v(_vm._s(_vm.gameData.gameType))]),
                ]),
              ]),
              _c("div", { staticClass: "content_head_right" }, [
                !_vm.hasLogin
                  ? _c("p", { staticClass: "notLogged" }, [
                      _vm._v(_vm._s(_vm.$t("log_in_game_account_text")) + " "),
                      _c(
                        "span",
                        {
                          staticClass: "color",
                          on: {
                            click: function ($event) {
                              return _vm.openLoginWindow()
                            },
                          },
                        },
                        [
                          _vm._v(
                            ", " +
                              _vm._s(_vm.$t("sign_in_lowercase_text")) +
                              " >>"
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm.hasLogin
                  ? _c("div", { staticClass: "content_head_role" }, [
                      _c("img", {
                        attrs: { src: _vm.gameData.gameIcon, alt: "" },
                      }),
                      _c("div", { staticClass: "Details" }, [
                        _c("div", { staticClass: "role-meta-row" }, [
                          _c("strong", { staticClass: "role-name" }, [
                            _vm._v(_vm._s(_vm.roleInfo.roleName)),
                          ]),
                          _c("p", { staticClass: "role-id" }, [
                            _vm._v("ID:"),
                            _c("span", [_vm._v(_vm._s(_vm.roleInfo.roleId))]),
                          ]),
                          _c("i", {
                            staticClass: "fa account fa-exchange color",
                            on: { click: _vm.openRoleChooseWindow },
                          }),
                        ]),
                        _c("p", { staticClass: "role-server" }, [
                          _vm._v("Server："),
                          _c("span", [_vm._v(_vm._s(_vm.roleInfo.serverName))]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm.isVipEnabled() && _vm.hasLogin
                ? _c("VipMemberHomeCard", {
                    attrs: { "game-data": _vm.gameData },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "game_tips_win" }, [
        _c("img", {
          staticClass: "close b-close",
          attrs: { src: require("../assets/image/winclose.png"), alt: "" },
        }),
        _c("img", {
          staticClass: "imagewin1",
          attrs: { src: _vm.gameData.popImage, alt: "" },
        }),
      ]),
      _c("RoleInfo", { on: { "init-role-info": _vm.initRoleInfo } }),
      _c("LoginWindow"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }